import { render, staticRenderFns } from "./GlobalInfoBar.vue?vue&type=template&id=7fd2dfae&scoped=true&"
import script from "./GlobalInfoBar.vue?vue&type=script&lang=js&"
export * from "./GlobalInfoBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalInfoBar.vue?vue&type=style&index=0&id=7fd2dfae&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd2dfae",
  null
  
)

export default component.exports